var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 3.09082H4.16797C3.13243 3.09082 2.29297 3.93029 2.29297 4.96582V16.6325C2.29297 17.668 3.13243 18.5075 4.16797 18.5075H6.66797C7.7035 18.5075 8.54297 17.668 8.54297 16.6325V4.96582C8.54297 3.93029 7.7035 3.09082 6.66797 3.09082Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 3.09082H13.332C12.2965 3.09082 11.457 3.93029 11.457 4.96582V7.46582C11.457 8.50135 12.2965 9.34082 13.332 9.34082H15.832C16.8676 9.34082 17.707 8.50135 17.707 7.46582V4.96582C17.707 3.93029 16.8676 3.09082 15.832 3.09082Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 12.2568H13.332C12.2965 12.2568 11.457 13.0963 11.457 14.1318V16.6318C11.457 17.6674 12.2965 18.5068 13.332 18.5068H15.832C16.8676 18.5068 17.707 17.6674 17.707 16.6318V14.1318C17.707 13.0963 16.8676 12.2568 15.832 12.2568Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterOverview);
export default __webpack_public_path__ + "static/media/master-overview.0f4b37d7.svg";
export { ForwardRef as ReactComponent };